import React from "react";
import { useTable, useResizeColumns } from "react-table";
import { Row, Col, Table } from "react-bootstrap";
import Paging from "./Paging";
import { FormProvider, useForm, useFormContext } from "react-hook-form";

function DataTable({ columns, data, config }) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows, // Instead of using 'rows', we'll use page,
  } = useTable(
    {
      columns,
      data: data?.data ?? [],
      initialState: { pageIndex: 0 },
    },
    useResizeColumns,
  );
  const methods = useFormContext();
  return (
    <>
      <Row>
        <Col xs="12" className="">
          <div className="bg-white">
            <Table
              {...getTableProps()}
              hover responsive
              className="mt-1 border-bottom"
            >
              <thead className="border-bottom">
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps({ style: { minWidth: column.minWidth, width: column.width, maxWidth: column.maxWidth, textAlign: column.align } })}>
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td
                            {...cell.getCellProps({
                              className: cell.column.className,
                            })}
                          >
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <Paging
              config={config}
              {...methods}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}

export default DataTable


